import { PostTypes } from 'constants/postTypes'
import React from 'react'
import { StyleSheet } from 'react-native'

import { BottomSheetNavbar } from 'partials/BottomSheetNavbar'
import { PostEditorForm } from 'partials/PostEditorForm'

import { Box } from 'widgets/Box'
import { LoadingSpinner } from 'widgets/LoadingSpinner'
import { Toast as ToastComponent } from 'widgets/Toast'

import { useKeyboardState } from 'hooks/useKeyboardState'
import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'
import { useWorkoutEditor } from 'hooks/useWorkoutEditor'

import { useCreatePostModal } from 'contexts/CreatePostModalContext'

const styles = StyleSheet.create({
  loadingContainer: {
    opacity: 0.6,
  },
})

export const ActivityDetails = ({ route, drawerNavigationRef }) => {
  const selectedGroup = route?.params?.selectedGroup
  const selectedType = route?.params?.selectedType

  const createPostModalRef = useCreatePostModal()
  const navigateBackOrHome = useNavigateBackOrHome()

  const {
    postFormData,
    createPostLoading,
    editPostLoading,
    saveMultipleSteps,
    deleteStepAtIndex,
    saveDetails,
    handlePublish,
  } = useWorkoutEditor({
    postType: PostTypes.ACTIVITY,
    isEditing: false,
    activityGroup: selectedGroup.toLowerCase(),
    activityType: selectedType,
    drawerNavigationRef,
  })

  const { height: keyboardHeight } = useKeyboardState()

  const loader = (
    <Box
      testID='LoadingSpinnerContainer'
      height='100%'
      width='100%'
      position='absolute'
      align='center'
      backgroundColor='white'
      justifyContent='center'
      style={styles.loadingContainer}
    >
      <LoadingSpinner />
    </Box>
  )

  return (
    <Box testID='ActivityDetailsPage' flexDirection='column' backgroundColor='white' flex={1}>
      <BottomSheetNavbar
        title={selectedType}
        onBack={() => {
          createPostModalRef?.current?.snapToIndex(1)
          navigateBackOrHome()
        }}
        onShare={handlePublish}
      />

      <Box
        flex={1}
        testID='ActivityDetailsContent'
        padding={{ top: 'sm', bottom: keyboardHeight }}
        width='100%'
        backgroundColor='white'
      >
        <PostEditorForm
          postFormData={postFormData}
          saveMultipleSteps={saveMultipleSteps}
          deleteStepAtIndex={deleteStepAtIndex}
          saveDetails={saveDetails}
        />
        <ToastComponent />
      </Box>
      {(createPostLoading || editPostLoading) && loader}
    </Box>
  )
}
